import { InsuranceProduct } from "Store/interfaces/products/checkout";

export const toggleProduct = (product: InsuranceProduct): void => {
  product.visible = !product.visible;
};
